import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

export const BudgetAlertsWidget = ({ data }) => {
  const alerts = (data?.budgetAlerts || []);
  if (alerts.length === 0) {
    return (
      <div
        className="border border-dashed border-slate-200 bg-slate-50 rounded-sm p-6 text-center"
        data-testid="widget-budget-alerts-empty"
      >
        <p className="text-sm font-ibm text-slate-500">No budget alerts. You&apos;re on track.</p>
      </div>
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="border-l-4 border-amber-500 bg-amber-50 rounded-sm overflow-hidden"
      data-testid="widget-budget-alerts"
    >
      <div className="p-5">
        <div className="flex items-start gap-3">
          <AlertTriangle className="text-amber-600 mt-0.5 flex-shrink-0" size={20} />
          <div className="flex-1">
            <h3 className="font-chivo font-bold text-slate-900 text-sm uppercase tracking-widest">
              Budget Alerts
            </h3>
            <ul className="mt-2 space-y-1" data-testid="widget-budget-alerts-list">
              {alerts.map((b) => (
                <li
                  key={b.id}
                  className="text-sm font-ibm text-slate-800"
                  data-testid={`widget-budget-alert-${b.category}`}
                >
                  <span className="font-semibold">{b.category}</span>{' '}
                  <span className={b.status === 'over' ? 'text-red-700 font-semibold' : 'text-amber-700'}>
                    {b.status === 'over' ? 'OVER BUDGET' : 'approaching limit'}
                  </span>{' '}
                  — ${b.spent.toLocaleString()} of ${b.monthly_limit.toLocaleString()} ({b.percent_used.toFixed(1)}%)
                </li>
              ))}
            </ul>
            <Link
              to="/budgets"
              data-testid="widget-budget-alerts-link"
              className="inline-block mt-3 text-xs font-ibm font-semibold uppercase tracking-widest text-slate-900 hover:underline"
            >
              Review Budgets →
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
